import {useSelector} from 'react-redux'

const useBroker = () => {
    const broker = useSelector(state => state.account.broker)
    return broker
}

export default useBroker